import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { OrderLine } from '@models/order';
import { useTranslation } from 'react-i18next';

interface Props {
    item: OrderLine;
}

function CartContent({ item }:Props) {
    const {
        itemName, totalAmount, status, defaultOptions, personalOptions,
    } = item;
    const { t } = useTranslation('cart');
    const options = [...personalOptions, ...defaultOptions]
        .map((optionGroup) => optionGroup.options)
        .flat();
    const isSoldOut = status === 'SOLD_OUT';
    const priceUnit = usePriceUnit();
    return (
        <TextContainer fullWidth spacing={10}>
            <Column>
                <Text size='lg' color={isSoldOut ? colors.gray5 : colors.gray6} fontWeight='bold'>
                    {itemName}
                </Text>
                <Text color={isSoldOut ? colors.gray5 : colors.gray6} size='lg'>
                    {options.map((option) => {
                        if (option.optionPrice) {
                            return `${option.optionName}(${option.quantity}${t('item.optionCount')})(+${option.optionPrice.toLocaleString()}${priceUnit})`;
                        }
                        return `${option.optionName}(${option.quantity}${t('item.optionCount')})`;
                    }).sort().join(' | ')}
                </Text>
            </Column>
            <Text color={isSoldOut ? colors.gray5 : colors.gray6} >
                <b>{totalAmount.toLocaleString()}</b>{priceUnit}
            </Text>
        </TextContainer>
    );
}

const TextContainer = styled(Column)`
    flex-grow: 1;
`;

export default CartContent;
